// extracted by mini-css-extract-plugin
export default {"header":"Header_header__TLw9l","headers":"Header_headers__rT2+9","settingbtn":"Header_settingbtn__qD6jI"};